import { parseInventoryUnits, parseNumericValue, type ConsignmentLineItem } from '@/entities/consignments';

// Same formats as the backend line mapper (`#,##0.0 kg`, `#,##0.00 m³`).
const formatWeight = (kg: number) =>
  `${kg.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} kg`;
const formatVolume = (m3: number) =>
  `${m3.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m³`;

/**
 * `units` of the line, e.g. on one pallet or loose: shown as `30 / 50 Each` with
 * the matching share of the line weight and volume. All of the line is returned
 * unchanged.
 */
export function linePart(line: ConsignmentLineItem, units: number): ConsignmentLineItem {
  const { quantity, unit } = parseInventoryUnits(line.inventoryUnits);
  if (quantity <= 0 || units >= quantity) return line;

  const share = units / quantity;
  return {
    ...line,
    inventoryUnits: `${units} / ${quantity} ${unit}`,
    weight: line.weight && formatWeight(parseNumericValue(line.weight) * share),
    volume: line.volume && formatVolume(parseNumericValue(line.volume) * share)
  };
}
